import { ReactComponent as PuzzleIcon } from "../../../assets/icons/puzzle-solid.svg";
import { useTheme } from "@mui/material";

const IconPuzzle: React.FC = (props) => {
  const theme = useTheme();

  return (
    <PuzzleIcon
      width="24px"
      height="24px"
      style={{
        padding: "2px",
        fill: theme.palette.text.primary,
      }}
    />
  );
};

export default IconPuzzle;
